import { useState } from "react";
import {
  useAddSelectionMutation,
  useLazyGetQueriesQuery,
} from "../../../redux/features/cache";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { Categorie } from "../../../models/Categorie";
import { Departement } from "../../../models/Departement";
import { Fournisseur } from "../../../models/Fournisseur";
import { Gamme } from "../../../models/Gamme";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { addRequestToSend } from "../../../redux/features/appStateSlice";
import { RequestToSend } from "../../../models/RequestToSend";

interface ISelectionForm {
  plans_seq: number | undefined;
  setAddSelection: any;
}

export default function SelectionForm({
  plans_seq,
  setAddSelection,
}: ISelectionForm) {
  const [dirty, setDirty] = useState<boolean>(false);
  const [trigger] = useLazyGetQueriesQuery();
  const [addSelection] = useAddSelectionMutation();
  const [dep, setDep] = useState<Departement[]>([]);
  const [four, setFour] = useState<Fournisseur[]>([]);
  const [gam, setGam] = useState<Gamme[]>([]);
  const [cat, setCat] = useState<Categorie[]>([]);
  const [defaultCategorie, setDefaultCategorie] = useState<Categorie | null>();
  const [defaultDepartement, setDefaultDepartement] =
    useState<Departement | null>();
  const [defaultFournisseur, setDefaultFournisseur] =
    useState<Fournisseur | null>();
  const [defaultGamme, setDefaultGamme] = useState<Gamme | null>();
  const [defaultMode, setDefaultMode] = useState<boolean>(true);
  const d_inv026 = useAppSelector((state) => state.appState.d_inv026);
  const dispatch = useAppDispatch();

  const getAutocomplete = async (
    event: any,
    queries: string,
    setState: any
  ) => {
    if (event !== null) {
      let rech = event.target.value;
      if (rech) {
        let result = await trigger(
          { queries, rech, treeView: false },
          true
        ).unwrap();
        setState(result);
      } else {
        setState([]);
      }
    }
  };

  const handleSub = async () => {
    let selection = {
      plans_seq: plans_seq,
      planss_mode: defaultMode,
      dept_cd: defaultDepartement !== null ? defaultDepartement?.dept_cd : "",
      cat_cd: defaultCategorie !== null ? defaultCategorie?.cat_cd : "",
      four_cd: defaultFournisseur !== null ? defaultFournisseur?.four_cd : "",
      gamme_cd: defaultGamme !== null ? defaultGamme?.gamme_cd : "",
    };
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Ajout sélection pour section ${plans_seq}`,
          addSelection,
          () => {
            setAddSelection(false);
          },
          {},
          selection,
          []
        )
      )
    );
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", pt: 2 }}>
        <TextField
          label="Mode"
          sx={{ width: "7vw", p: 1, mr: 3 }}
          onChange={(e) => {
            setDirty(true);
            setDefaultMode(e.target.value === "true");
          }}
          defaultValue={defaultMode}
          select
        >
          <MenuItem value={true as any}>Inclus</MenuItem>
          <MenuItem value={false as any}>Exclus</MenuItem>
        </TextField>
        <Autocomplete
          options={dep}
          clearOnBlur={false}
          defaultValue={defaultDepartement}
          getOptionLabel={(cat) => `${cat.dept_cd} ${cat.dept_nom}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultDepartement(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "departement", setDep);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{
                color: "red",
              }}
              {...params}
              label="Departement"
            />
          )}
        />
        <Autocomplete
          options={cat}
          clearOnBlur={false}
          getOptionLabel={(cat) => `${cat.cat_cd} ${cat.cat_descr}`}
          defaultValue={defaultCategorie}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultCategorie(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "categories", setCat);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => <TextField {...params} label="Categories" />}
        />
        <Autocomplete
          options={four}
          clearOnBlur={false}
          defaultValue={defaultFournisseur}
          getOptionLabel={(cat) => `${cat.four_cd} ${cat.four_nom}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultFournisseur(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "fournisseur", setFour);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => (
            <TextField {...params} label="Fournisseur" />
          )}
        />
        <Autocomplete
          options={gam}
          clearOnBlur={false}
          defaultValue={defaultGamme}
          getOptionLabel={(cat) => `${cat.gamme_cd} ${cat.gamme_descr}`}
          onChange={(e, data) => {
            setDirty(true);
            setDefaultGamme(data);
          }}
          onInputChange={(event) => {
            getAutocomplete(event, "gamme", setGam);
          }}
          sx={{ width: "15vw", p: 1 }}
          renderInput={(params) => <TextField {...params} label="Gamme" />}
        />

        <Tooltip title="Enregistrer">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!dirty ? "custom-disabled" : ""}`}
          >
            <span
              className={`k-icon k-font-icon k-i-save k-icon-xl`}
              onClick={handleSub}
            ></span>
          </span>
        </Tooltip>
        <Tooltip title="Annuler">
          <span style={{ display: "flex" }}>
            <Button
              disabled={!d_inv026.canDelete}
              onClick={() => setAddSelection(false)}
              color="error"
            >
              <DeleteIcon />{" "}
            </Button>
          </span>
        </Tooltip>
      </Box>
    </>
  );
}
